import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  Typography,
  LinearProgress,
  TextField,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Switch,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import { display } from "@mui/system";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  ExpandLess,
  ExpandMore,
  Edit,
  Delete,
  ReportProblemOutlined as ReportProblemOutlinedIcon,
} from "@mui/icons-material";
import TipIconNew from "../../assets/icons/tip-icon.svg";
import PdfIcon from "../../assets/icons/pdf-icon.svg";
import AppointmentCalenderIcon from "../../assets/icons/appointment-calender-icon.svg";
import { useAppContext } from "../../context/AppContext";
import { GetAllUserAppointment } from "../../helpers/Appointment";
import moment from "moment";
import Toast from "../../components/toast";
import {
  getMedicalFormForReview,
  updateMedicalForm,
} from "../../helpers/MedicalForms";
import styled from "@emotion/styled";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";

const ReviewPatientForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { chatId } = location.state || {};
  const { userData, isMobile, unsavedChanges, registerUnsavedChanges, guardedNavigate } = useAppContext();
  const [incomingChatId, setInComingChatId] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isAddMedication, setIsAddMedication] = useState(false);



  const [formData, setFormData] = useState({
    evaluationTpye: "",
    dob: "",
    weight: "",
    height: "",
    ssn: "",
    address: "",
    gender: "",
    phone: "",
    city: "",
    zip: "",
    state: "",
    reasonForEvaluation: "",
    reasonForEvaluationOther: "",
    currentDiagnosis: "",
    physicalLimitations: "",
    mentalHealthLimitations: "",
    treatmentTherapies: "",
    supportiveServices: "",
    allergies: "",
    dietInstructions: "",
    dietInstructionsOther: "",
    ambulating: "",
    bathing: "",
    dressing: "",
    eating: "",
    ambulating: "",
    grooming: "",
    skinIntegrity: "",
    skinIntegrityLocation: "",
    toileting: "",
    transferring: "",
    restraints: "",
    chemicalRestraint: "",
    physicalRestraint: "",
    receviedTBScreening: "",
    infectiousSigns: "",
    tbScreeningDate: "",
    tbScreeningResults: "",
    poseDanger: "",
    poseDangerExplain: "",
    nightAssistance: "",
    nightAssistanceExplain: "",
    nursingSupervision: "",
    placementInMemoryCareUnit: "",
    assistedLiving: "",
    signatureOfPhysician: "",
    date: "",
    patientName: "",
    georgiaLicense: "",
    physicianAddress: "",
    facilityName: "",
    contactPerson: "",
    facilityAddress: "",
    facilityCity: "",
    facilityState: "",
    facilityZip: "",
  });
  const [medications, setMedications] = useState([]);
  const [formValues, setFormValues] = useState({
    Medication: "",
    Dosage: "",
    Directions: "",
    Route: "",
    NeedHelp: false,
    id: 0,
  });
  const [sectionView, setSectionView] = useState({
    DEMOGRAPHICS: true,
    PME: true,
    POLST: true,
    OTHER: true,
  });

  const [openMedicationPopup, setOpenMedicationPopup] = useState(false);

  const GetAllFormhanlder = async (_chatId) => {
    setIsLoading(true);
    const response = await getMedicalFormForReview(_chatId);
    if (response.statusCode === 200 && response.isSuccess === true) {
      const data = response.data;
      setFormData(data.finalDetails);
      setIsSubmitted(data.formStatus === "Submitted to Admin" ? true : false);
      if (data.medications && Array.isArray(data.medications)) {
        setMedications(
          data.medications.map((med) => ({
            Medication: med.medication || "",
            Dosage: med.dosage || "",
            Directions: med.direction || "",
            Route: med.route || "",
            NeedHelp: med.needsHelp || false,
            id: med.id || 0,
          })),
        );
      }
    } else {
      Toast.error(response.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (chatId) {
      setInComingChatId(chatId);
      GetAllFormhanlder(chatId);
      setIsDisabled(true);
    } else {
      navigate(-1);
    }
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (unsavedChanges) {
        e.preventDefault();
        e.returnValue = ""; // required for Chrome to show the native prompt
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [unsavedChanges]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClickArrow = (section) => {
    setSectionView((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleEditMedication = (row) => {
    setFormValues({
      id: row.id,
      Medication: row.Medication,
      Dosage: row.Dosage,
      Directions: row.Directions,
      Route: row.Route,
      NeedHelp: row.NeedHelp,
    });
    setIsAddMedication(true);
  };

  const handleDeleteMedication = (idx) => {
    const _medications = medications.filter((med, i) => med.id !== idx);
    setMedications(_medications);
    registerUnsavedChanges(true);
  };

  const handleAddMedication = () => {
    if (isAddMedication) {
      if (formValues.Medication.trim() === "") {
        Toast.error("Enter Medication");
        return;
      } else if (formValues.Dosage.trim() === "") {
        Toast.error("Enter Dosage");
        return;
      } else if (formValues.Directions.trim() === "") {
        Toast.error("Enter Directions");
        return;
      } else if (formValues.Route.trim() === "") {
        Toast.error("Enter Route");
        return;
      }

      const _medications = medications;
      if (formValues.id && formData.id !== 0) {
        const index = _medications.findIndex((med) => med.id === formValues.id);
        if (index !== -1) {
          _medications[index] = {
            ...formValues,
          };
        }
      } else {
        _medications.push({
          ...formValues,
          id:
            medications.length > 0
              ? medications[medications.length - 1].id + 1
              : 1,
        });
      }
      setMedications(_medications);
      registerUnsavedChanges(true);
      setFormValues({
        Medication: "",
        Dosage: "",
        Directions: "",
        Route: "",
        NeedHelp: false,
        id: 0,
      });
      setIsAddMedication(false);
    } else {
      setIsAddMedication(true);
    }
  };

  const handleSaveForm = async () => {
    // Example: Inside your controller or before calling the service
    // const payload = {
    //   // Basic Info
    //   evaluationType: formData.evaluationType,
    //   dob: formData.dob,
    //   weight: formData.weight,
    //   height: formData.height,
    //   ssn: formData.ssn,
    //   address: formData.address,
    //   gender: formData.gender,
    //   phone: formData.phone,
    //   city: formData.city,
    //   zip: formData.zip,
    //   state: formData.state,
    //   patientName: formData.patientName,

    //   // Reasons & Diagnoses
    //   reasonForEvaluation: formData.reasonForEvaluation,
    //   reasonForEvaluationOther: formData.reasonForEvaluationOther,

    //   currentDiagnosis: formData.currentDiagnosis,
    //   currentDiagnosisOther: formData.currentDiagnosisOther,

    //   physicalLimitations: formData.physicalLimitations,
    //   physicalLimitationsOther: formData.physicalLimitationsOther,

    //   mentalHealthLimitations: formData.mentalHealthLimitations,
    //   mentalHealthLimitationsOther: formData.mentalHealthLimitationsOther,

    //   treatmentTherapies: formData.treatmentTherapies,
    //   treatmentTherapiesOther: formData.treatmentTherapiesOther,

    //   supportiveServices: formData.supportiveServices,
    //   supportiveServicesOther: formData.supportiveServicesOther,

    //   // Allergies
    //   allergies: formData.allergies,
    //   allergiesOther: formData.allergiesOther,
    //   allergiesMedication: formData.allergiesMedication,
    //   allergiesFood: formData.allergiesFood,
    //   allergiesFoodDetail: formData.allergiesFoodDetail,
    //   allergiesMedicationDetail: formData.allergiesMedicationDetail,

    //   // ADL (Activities of Daily Living)
    //   dietInstructions: formData.dietInstructions,
    //   dietInstructionsOther: formData.dietInstructionsOther,
    //   ambulating: formData.ambulating,
    //   bathing: formData.bathing,
    //   dressing: formData.dressing,
    //   eating: formData.eating,
    //   grooming: formData.grooming,
    //   skinIntegrity: formData.skinIntegrity,
    //   skinIntegrityLocation: formData.skinIntegrityLocation,
    //   toileting: formData.toileting,
    //   transferring: formData.transferring,

    //   // Safety & Medical
    //   restraints: formData.restraints,
    //   chemicalRestraint: formData.chemicalRestraint,
    //   physicalRestraint: formData.physicalRestraint,
    //   receviedTBScreening: formData.receviedTBScreening,
    //   tbScreeningDate: formData.tbScreeningDate,
    //   poseDanger: formData.poseDanger,
    //   poseDangerExplain: formData.poseDangerExplain,
    //   nightAssistance: formData.nightAssistance,
    //   nightAssistanceExplain: formData.nightAssistanceExplain,
    //   nursingSupervision: formData.nursingSupervision,
    //   placementInMemoryCareUnit: formData.placementInMemoryCareUnit,

    //   // Facility
    //   facilityType: formData.facilityType,
    //   facilityName: formData.facilityName,
    //   facilityNameOther: formData.facilityNameOther,
    //   contactPerson: formData.contactPerson,
    //   facilityAddress: formData.facilityAddress,

    //   // POLST
    //   cardiopulmonaryResuscitation: formData.cardiopulmonaryResuscitation,
    //   cardiopulmonaryResuscitationOrders:
    //     formData.cardiopulmonaryResuscitationOrders,
    //   medicalInterventions: formData.medicalInterventions,
    //   medicalInterventionsOrders: formData.medicalInterventionsOrders,
    //   antibiotics: formData.antibiotics,
    //   antibioticsOrders: formData.antibioticsOrders,
    //   artificiallyAdministeredFluids:
    //     formData.artificiallyAdministeredFluids,
    //   artificiallyAdministeredFluidsOrders:
    //     formData.artificiallyAdministeredFluidsOrders,

    //   // Wound Care
    //   woundPeriod: formData.woundPeriod,
    //   woundTreatment: formData.woundTreatment,
    //   woundTreatmentPhysician: formData.woundTreatmentPhysician,
    // };
    try {
      setIsLoading(true);
      const updatedMedications = medications.map((med) => ({
        id: med.id,
        medication: med.Medication,
        dosage: med.Dosage,
        direction: med.Directions,
        route: med.Route,
        needsHelp: med.NeedHelp,
      }));
      const payload = {
        chatId: incomingChatId,
        payload: formData,
        medications: updatedMedications,
      };
      const response = await updateMedicalForm(payload);
      if (response.statusCode === 200 && response.isSuccess === true) {
        Toast.success(response.message);
        setIsDisabled(true);
        registerUnsavedChanges(false);
        GetAllFormhanlder(chatId);
      } else {
        Toast.error(response.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      Toast.error(error.message || "An error occurred while saving the form.");
    }
  };

  const styles = {
    TableContainer: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      overflowX: "hidden",
      overflowY: "hidden",
    },
    tableCell: {
      color: "#6B6B6B",
    },
    contentBox: {
      my: 2,
      borderRadius: "8px",
      border: "1px solid #D6D6D6",
      backgroundColor: "#ffffff",
      overflow: "hidden",
    },
    contentBoxInner: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#FCFCFC",
      paddingX: 2,
      paddingY: 2,
      cursor: "pointer",
    },
  };

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#65C466",
          opacity: 1,
          border: 0,
          ...theme.applyStyles("dark", {
            backgroundColor: "#2ECA45",
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...theme.applyStyles("dark", {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...theme.applyStyles("dark", {
          opacity: 0.3,
        }),
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...theme.applyStyles("dark", {
        backgroundColor: "#39393D",
      }),
    },
  }));

  console.log("Patient Name", formData);

  return (
    <Box sx={styles.TableContainer}>
      <Box style={{ width: "100%", paddingBottom: 20 }}>
        <Typography
          variant="body2"
          color="primary"
          mb={2}
          sx={{
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => {
            guardedNavigate(navigate, -1);
          }}
        >
          <KeyboardBackspaceOutlinedIcon
            fontSize="small"
            sx={{ verticalAlign: "middle", mr: 0.5, fontWeight: "medium" }}
          />
          Back
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            my: 1,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <Typography
              fontSize={"24px"}
              marginBottom={0}
              className="sf-medium sf-medium--dark"
            >
              Review Patient Form:&nbsp;{" "}
              <span className="sf-regular sf-regular--primary">
                {formData.patientName ?? ""}
              </span>
            </Typography>
          </Box>
          <Button
            variant="outlined"
            size="small"
            className="sf-medium sf-medium--primary"
            sx={{ display: isDisabled ? "flex" : "none" }}
            onClick={() => {
              if (!isSubmitted) setIsDisabled(false);
            }}
            disabled={isSubmitted}
            startIcon={!isSubmitted && <Edit />}
          >
            {isSubmitted === true ? "Already Submitted" : "Edit & Review Form"}
          </Button>
        </Box>

        <Box sx={styles.contentBox}>
          <Box
            sx={styles.contentBoxInner}
            onClick={() => handleClickArrow("DEMOGRAPHICS")}
          >
            <Typography fontSize={"16px"} className="sf-bold sf-bold--dark">
              Patient's Demographics
            </Typography>
            {sectionView["DEMOGRAPHICS"] === true ? (
              <ExpandLess sx={{ fontSize: 24 }} className="color-primary" />
            ) : (
              <ExpandMore sx={{ fontSize: 24 }} className="color-primary" />
            )}
          </Box>
          <Divider sx={{ width: "100%" }} />
          {sectionView["DEMOGRAPHICS"] === true ? (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ p: 2 }}>
                <Grid container rowSpacing={2} columnSpacing={{ xs: 2, md: 3 }}>
                  <Grid item size={{ xs: 6, md: 4 }}>
                    <Typography classNam="sf-regular sf-regular-dark">
                      Date of Birth
                    </Typography>
                    {/* <TextField
                      size="small"
                      fullWidth
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleInputChange}
                      disabled={isDisabled}
                    /> */}
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Enter your height"
                      variant="outlined"
                      name="dob"
                      value={formData.dob}
                      onChange={handleInputChange}
                      disabled={isDisabled}
                    />
                  </Grid>
                  {/* <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography sx={{ mb: 1, fontWeight: 500 }}>
                        Date of Birth
                      </Typography>

                      <DatePicker
                        value={dayjs("2026-01-01")}
                        format="MM/DD/YYYY"
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            placeholder: "MM/DD/YYYY",
                            sx: {
                              padding: 0,
                              "& .MuiOutlinedInput-root": {
                                "& input": {
                                  padding: "15px 5px",
                                },
                              },
                            },
                          },
                        }}
                      />
                    </Grid> */}
                  <Grid item size={{ xs: 6, md: 4 }}>
                    <Typography classNam="sf-regular sf-regular-dark">
                      Height
                    </Typography>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Enter your height"
                      variant="outlined"
                      name="height"
                      value={formData.height}
                      onChange={handleInputChange}
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Grid item size={{ xs: 6, md: 4 }}>
                    <Typography classNam="sf-regular sf-regular-dark">
                      Weight
                    </Typography>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Enter your weight"
                      variant="outlined"
                      name="weight"
                      value={formData.weight}
                      onChange={handleInputChange}
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Grid item size={{ xs: 6, md: 2 }}>
                    <Typography classNam="sf-regular sf-regular-dark">
                      Last Four Digits of SSN
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter your weight"
                      variant="outlined"
                      name="ssn"
                      value={formData.ssn}
                      onChange={handleInputChange}
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Grid item size={{ xs: 6, md: 2 }}>
                    <Typography className="sf-regular sf-regular-dark" sx={{}}>
                      Gender
                    </Typography>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        row
                        name="gender"
                        value={formData.gender}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: "start",
                          gap: 0,
                          padding: 0,
                        }}
                      >
                        <FormControlLabel
                          value="Male"
                          control={<Radio />}
                          label="Male"
                          sx={{ mt: -1 }}
                        />
                        <FormControlLabel
                          value="Female"
                          control={<Radio />}
                          label="Female"
                          sx={{ mt: -1 }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item size={{ xs: 6, md: 4 }}>
                    <Typography classNam="sf-regular sf-regular-dark">
                      Present Address
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter your weight"
                      variant="outlined"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Grid item size={{ xs: 6, md: 4 }}>
                    <Typography classNam="sf-regular sf-regular-dark">
                      Phone
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter your phone number"
                      variant="outlined"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Grid item size={{ xs: 6, md: 4 }}>
                    <Typography classNam="sf-regular sf-regular-dark">
                      City
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter your city"
                      variant="outlined"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Grid item size={{ xs: 6, md: 4 }}>
                    <Typography classNam="sf-regular sf-regular-dark">
                      Zip
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter your weight"
                      variant="outlined"
                      name="zip"
                      value={formData.zip}
                      onChange={handleInputChange}
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Grid item size={{ xs: 6, md: 4 }}>
                    <Typography classNam="sf-regular sf-regular-dark">
                      State
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter your state"
                      variant="outlined"
                      name="state"
                      value={formData.state}
                      onChange={handleInputChange}
                      disabled={isDisabled}
                    />
                  </Grid>
                </Grid>
              </Box>
            </LocalizationProvider>
          ) : (
            ""
          )}
        </Box>

        <Box sx={styles.contentBox}>
          <Box
            sx={styles.contentBoxInner}
            onClick={() => handleClickArrow("PME")}
          >
            <Typography fontSize={"16px"} className="sf-bold sf-bold--dark">
              PME Form
            </Typography>
            {sectionView["PME"] === true ? (
              <ExpandLess sx={{ fontSize: 24 }} className="color-primary" />
            ) : (
              <ExpandMore sx={{ fontSize: 24 }} className="color-primary" />
            )}
          </Box>
          <Divider sx={{ width: "100%" }} />
          {sectionView["PME"] === true ? (
            <Box sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Typography
                    className="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px" }}
                  >
                    REASON FOR EVALUATION
                  </Typography>

                  <FormControl disabled={isDisabled}>
                    <RadioGroup
                      row
                      name="reasonForEvaluation"
                      value={formData.reasonForEvaluation}
                      onChange={handleInputChange}
                      sx={{
                        flexWrap: "nowrap", // 👈 prevents wrapping
                        alignItems: "center",
                        gap: 0,
                      }}
                    >
                      <FormControlLabel
                        value="Moving or transferring into an assisted living community"
                        control={<Radio />}
                        label="Pre-Admission"
                      />
                      <FormControlLabel
                        value="PME Annual"
                        control={<Radio />}
                        label="Annual"
                      />
                      <FormControlLabel
                        value="Moving to higher level of care within the community"
                        control={<Radio />}
                        label="Possible Change in patient's condition"
                      />
                      <FormControlLabel
                        value="Other"
                        control={<Radio />}
                        label="Other"
                      />
                      <TextField
                        type="text"
                        name="reasonForEvaluationOther"
                        value={formData.reasonForEvaluationOther}
                        onChange={handleInputChange}
                        disabled={
                          formData.reasonForEvaluation !== "Other" || isDisabled
                        } // 👈 optional but recommended
                        sx={{
                          width: 180,
                          mb: 1,
                        }}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    1. Current Diagnosis(es)
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="currentDiagnosis"
                    value={formData.currentDiagnosis}
                    onChange={handleInputChange}
                    disabled={isDisabled}
                  />
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    2. Physical Limitations
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="physicalLimitations"
                    value={formData.physicalLimitations}
                    onChange={handleInputChange}
                    disabled={isDisabled}
                  />
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    3. Mental Health Limitations
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="mentalHealthLimitations"
                    value={formData.mentalHealthLimitations}
                    onChange={handleInputChange}
                    disabled={isDisabled}
                  />
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    4. Treatment/Therapies (Describe medical services or nursing
                    care or treatment needed.)
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="treatmentTherapies"
                    value={formData.treatmentTherapies}
                    onChange={handleInputChange}
                    disabled={isDisabled}
                  />
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    5. Supportive Services Needed
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="supportiveServices"
                    value={formData.supportiveServices}
                    onChange={handleInputChange}
                    disabled={isDisabled}
                  />
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    6. Allergies
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="allergies"
                    value={formData.allergies}
                    onChange={handleInputChange}
                    disabled={isDisabled}
                  />
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Typography
                    className="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px" }}
                  >
                    7. DIET INSTRUCTIONS
                  </Typography>

                  <FormControl disabled={isDisabled}>
                    <RadioGroup
                      row={isMobile ? false : true}
                      name="dietInstructions"
                      value={formData.dietInstructions}
                      onChange={handleInputChange}
                      sx={{
                        flexWrap: "nowrap", // 👈 prevents wrapping
                        alignItems: isMobile ? "start" : "center",
                        gap: 0,
                      }}
                    >
                      <FormControlLabel
                        value="Regular"
                        control={<Radio />}
                        label="Regular"
                      />
                      <FormControlLabel
                        value="No added table salt"
                        control={<Radio />}
                        label="No added table salt"
                      />
                      <FormControlLabel
                        value="No concentrated sweets"
                        control={<Radio />}
                        label="No concentrated sweets"
                      />
                      <FormControlLabel
                        value="Other"
                        control={<Radio />}
                        label="Other"
                      />
                      <TextField
                        size="small"
                        type="text"
                        name="dietInstructionsOther"
                        value={formData.dietInstructionsOther}
                        onChange={handleInputChange}
                        disabled={
                          formData.dietInstructions !== "Other" || isDisabled
                        } // 👈 optional but recommended
                        sx={{
                          width: 180,
                          mb: 1,
                        }}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Divider sx={{ width: "100%" }} />

                <Grid item size={{ xs: 12, md: 12 }}>
                  <Typography
                    className="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px" }}
                  >
                    8. STATUS OF THE FOLLOWING:
                  </Typography>

                  <Box sx={{ p: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography className="sf-regular sf-regular-dark">
                          AMBULATING
                        </Typography>
                        <FormControl disabled={isDisabled}>
                          <RadioGroup
                            row={false}
                            name="ambulating"
                            value={formData.ambulating}
                            onChange={handleInputChange}
                            sx={{
                              flexWrap: "nowrap", // 👈 prevents wrapping
                              alignItems: "start",
                            }}
                          >
                            <FormControlLabel
                              value="Independent"
                              control={<Radio />}
                              label="Independent"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need supervision"
                              control={<Radio />}
                              label="Needs supervision"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need assistance"
                              control={<Radio />}
                              label="Needs assistance"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need total help"
                              control={<Radio />}
                              label="Needs total help"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Bedridden"
                              control={<Radio />}
                              label="Bedridden"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography className="sf-regular sf-regular-dark">
                          BATHING
                        </Typography>
                        <FormControl disabled={isDisabled}>
                          <RadioGroup
                            row={false}
                            name="bathing"
                            value={formData.bathing}
                            onChange={handleInputChange}
                            sx={{
                              flexWrap: "nowrap", // 👈 prevents wrapping
                              alignItems: "start",
                            }}
                          >
                            <FormControlLabel
                              value="Independent"
                              control={<Radio />}
                              label="Independent"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need supervision"
                              control={<Radio />}
                              label="Needs supervision"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need assistance"
                              control={<Radio />}
                              label="Needs assistance"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need total help"
                              control={<Radio />}
                              label="Needs total help"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography className="sf-regular sf-regular-dark">
                          DRESSING
                        </Typography>
                        <FormControl disabled={isDisabled}>
                          <RadioGroup
                            row={false}
                            name="dressing"
                            value={formData.dressing}
                            onChange={handleInputChange}
                            sx={{
                              flexWrap: "nowrap", // 👈 prevents wrapping
                              alignItems: "start",
                            }}
                          >
                            <FormControlLabel
                              value="Independent"
                              control={<Radio />}
                              label="Independent"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need supervision"
                              control={<Radio />}
                              label="Needs supervision"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need assistance"
                              control={<Radio />}
                              label="Needs assistance"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need total help"
                              control={<Radio />}
                              label="Needs total help"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography className="sf-regular sf-regular-dark">
                          EATING
                        </Typography>
                        <FormControl disabled={isDisabled}>
                          <RadioGroup
                            row={false}
                            name="eating"
                            value={formData.eating}
                            onChange={handleInputChange}
                            sx={{
                              flexWrap: "nowrap", // 👈 prevents wrapping
                              alignItems: "start",
                            }}
                          >
                            <FormControlLabel
                              value="Independent"
                              control={<Radio />}
                              label="Independent"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need supervision"
                              control={<Radio />}
                              label="Needs supervision"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need assistance"
                              control={<Radio />}
                              label="Needs assistance"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need help with Tube Feeding"
                              control={<Radio />}
                              label="Need help with Tube Feeding"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography className="sf-regular sf-regular-dark">
                          GROOMING
                        </Typography>
                        <FormControl disabled={isDisabled}>
                          <RadioGroup
                            row={false}
                            name="grooming"
                            value={formData.grooming}
                            onChange={handleInputChange}
                            sx={{
                              flexWrap: "nowrap", // 👈 prevents wrapping
                              alignItems: "start",
                            }}
                          >
                            <FormControlLabel
                              value="Independent"
                              control={<Radio />}
                              label="Independent"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need supervision"
                              control={<Radio />}
                              label="Needs supervision"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need assistance"
                              control={<Radio />}
                              label="Needs assistance"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need total help"
                              control={<Radio />}
                              label="Needs total help"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography className="sf-regular sf-regular-dark">
                          SKIN INTEGRITY
                        </Typography>
                        <FormControl disabled={isDisabled}>
                          <RadioGroup
                            row={false}
                            name="skinIntegrity"
                            value={formData.skinIntegrity}
                            onChange={handleInputChange}
                            sx={{
                              flexWrap: "nowrap", // 👈 prevents wrapping
                              alignItems: "start",
                            }}
                          >
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No pressure sores"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Stage one"
                              control={<Radio />}
                              label="Stage one"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Stage two"
                              control={<Radio />}
                              label="Stage two"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Stage three"
                              control={<Radio />}
                              label="Stage three"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Stage four"
                              control={<Radio />}
                              label="Stage four"
                              sx={{ mb: -1 }}
                            />
                            <TextField
                              type="text"
                              name="skinIntegrityLocation"
                              value={formData.skinIntegrityLocation}
                              onChange={handleInputChange}
                              sx={{
                                width: 150,
                              }}
                              disabled={isDisabled}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography className="sf-regular sf-regular-dark">
                          TOILETING
                        </Typography>
                        <FormControl disabled={isDisabled}>
                          <RadioGroup
                            row={false}
                            name="toileting"
                            value={formData.toileting}
                            onChange={handleInputChange}
                            sx={{
                              flexWrap: "nowrap", // 👈 prevents wrapping
                              alignItems: "start",
                            }}
                          >
                            <FormControlLabel
                              value="Independent"
                              control={<Radio />}
                              label="Independent"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need supervision"
                              control={<Radio />}
                              label="Needs supervision"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need hygiene assistance"
                              control={<Radio />}
                              label="Hygiene assistance"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need adult briefs"
                              control={<Radio />}
                              label="Adult briefs"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need a Foley catheter"
                              control={<Radio />}
                              label="Catheter care assistance"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Have an ostomy"
                              control={<Radio />}
                              label="Ostomy"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography className="sf-regular sf-regular-dark">
                          TRANSFERRING
                        </Typography>
                        <FormControl disabled={isDisabled}>
                          <RadioGroup
                            row={false}
                            name="transferring"
                            value={formData.transferring}
                            onChange={handleInputChange}
                            sx={{
                              flexWrap: "nowrap", // 👈 prevents wrapping
                              alignItems: "start",
                            }}
                          >
                            <FormControlLabel
                              value="Independent"
                              control={<Radio />}
                              label="Independent"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need supervision"
                              control={<Radio />}
                              label="Needs supervision"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need assistance"
                              control={<Radio />}
                              label="Needs assistance"
                              sx={{ mb: -2 }}
                            />
                            <FormControlLabel
                              value="Need total help"
                              control={<Radio />}
                              label="Needs total help"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item size={{ xs: 12, md: 12 }}>
                        <Typography className="sf-regular sf-regular-dark">
                          RESTRAINTS
                        </Typography>
                        <FormControl disabled={isDisabled}>
                          <RadioGroup
                            row={isMobile ? false : true}
                            name="restraints"
                            value={formData.restraints}
                            onChange={handleInputChange}
                            sx={{
                              flexWrap: "nowrap", // 👈 prevents wrapping
                              alignItems: isMobile ? "start" : "center",
                              gap: 0,
                            }}
                          >
                            <FormControlLabel
                              value="Requires no restraints"
                              control={<Radio />}
                              label="Requires no restraints"
                            />
                            <FormControlLabel
                              value="Require chemical restraints"
                              control={<Radio />}
                              label="Require chemical restraints"
                            />
                            <TextField
                              type="text"
                              name="chemicalRestraint"
                              value={formData.chemicalRestraint}
                              onChange={handleInputChange}
                              disabled={
                                formData.restraints !==
                                "Require chemical restraints" || isDisabled
                              }
                              sx={{
                                width: 150,
                                mb: 1,
                                mr: 1,
                              }}
                            />
                            <FormControlLabel
                              value="Require physical restraints"
                              control={<Radio />}
                              label="Require physical restraints"
                            />
                            <TextField
                              type="text"
                              name="physicalRestraint"
                              value={formData.physicalRestraint}
                              onChange={handleInputChange}
                              disabled={
                                formData.restraints !==
                                "Require physical restraints" || isDisabled
                              }
                              sx={{
                                width: 150,
                                mb: 1,
                              }}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Typography
                    className="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px" }}
                  >
                    9. SELECT THE APPROPRIATE ANSWER IN EACH STATEMENT BELOW.
                  </Typography>
                  <Typography
                    component="div"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <span>a. The individual</span>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        row={true}
                        name="receviedTBScreening"
                        value={formData.receviedTBScreening}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: isMobile ? "start" : "center",
                          gap: 0,
                          ml: 2,
                        }}
                      >
                        <FormControlLabel
                          value="HAS received screening"
                          control={<Radio />}
                          label="HAS"
                        />
                        <FormControlLabel
                          value="HAS NOT received screening"
                          control={<Radio />}
                          label="HAS NOT"
                        />
                      </RadioGroup>
                    </FormControl>
                    <span>received Screening for TB and the individual</span>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        row={true}
                        name="infectiousSigns"
                        value={formData.infectiousSigns}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: isMobile ? "start" : "center",
                          gap: 0,
                          ml: 2,
                        }}
                      >
                        <FormControlLabel
                          value="HAS"
                          control={<Radio />}
                          label="HAS"
                        />
                        <FormControlLabel
                          value="HAS NOT"
                          control={<Radio />}
                          label="HAS NOT"
                        />
                      </RadioGroup>
                    </FormControl>
                    <span>signs and/or </span>
                    <span>
                      symptoms of infectious diseases which are likely to be
                      transmitted to other residents or staff.
                    </span>
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Typography
                    component="div"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <span>TB SCREENING INFORMATION:&nbsp;</span>
                    <TextField
                      size="small"
                      type="text"
                      name="tbScreeningDate"
                      value={formData.tbScreeningDate}
                      placeholder="Date"
                      onChange={handleInputChange}
                      disabled={
                        formData.receviedTBScreening !== "HAS" || isDisabled
                      } // 👈 optional but recommended
                      sx={{
                        width: 180,
                        mb: 1,
                      }}
                    />
                    <TextField
                      size="small"
                      type="text"
                      name="tbScreeningResults"
                      value={formData.tbScreeningResults}
                      placeholder="Results"
                      onChange={handleInputChange}
                      disabled={
                        formData.receviedTBScreening !== "HAS" || isDisabled
                      } // 👈 optional but recommended
                      sx={{
                        width: 180,
                        mb: 1,
                        ml: 1,
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Typography
                    component="div"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <span>b. The individual's behavior</span>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        row={true}
                        name="poseDanger"
                        value={formData.poseDanger}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: isMobile ? "start" : "center",
                          gap: 0,
                          ml: 2,
                        }}
                      >
                        <FormControlLabel
                          value="DOES pose a danger"
                          control={<Radio />}
                          label="DOES"
                        />
                        <FormControlLabel
                          value="DOES NOT pose a danger"
                          control={<Radio />}
                          label="DOES NOT"
                        />
                      </RadioGroup>
                    </FormControl>
                    <span>
                      {" "}
                      a danger to self or others. If DOES, please explain.
                    </span>
                    <span>
                      {" "}
                      If medications are necessary to control behavior, please
                      explain.
                    </span>
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="poseDangerExplain"
                    value={formData.poseDangerExplain}
                    onChange={handleInputChange}
                    disabled={isDisabled}
                  />
                </Grid>
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Typography
                    component="div"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <span>c. The individual&nbsp;</span>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        row={true}
                        name="nightAssistance"
                        value={formData.nightAssistance}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: isMobile ? "start" : "center",
                          gap: 0,
                          ml: 2,
                        }}
                      >
                        <FormControlLabel
                          value="DOES require assistance"
                          control={<Radio />}
                          label="DOES"
                        />
                        <FormControlLabel
                          value="DOES NOT require assistance"
                          control={<Radio />}
                          label="DOES NOT"
                        />
                      </RadioGroup>
                    </FormControl>
                    <span>
                      {" "}
                      require assistance from staff during night. If assistance
                      is required, please explain.
                    </span>
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="nightAssistanceExplain"
                    value={formData.nightAssistanceExplain}
                    onChange={handleInputChange}
                    disabled={isDisabled}
                  />
                </Grid>
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Typography
                    component="div"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <span>d. The individual&nbsp;</span>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        row={true}
                        name="nursingSupervision"
                        value={formData.nursingSupervision}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: isMobile ? "start" : "center",
                          gap: 0,
                          ml: 2,
                        }}
                      >
                        <FormControlLabel
                          value="DOES require"
                          control={<Radio />}
                          label="DOES"
                        />
                        <FormControlLabel
                          value="DOES NOT require"
                          control={<Radio />}
                          label="DOES NOT"
                        />
                      </RadioGroup>
                    </FormControl>
                    <span> require 24 hours nursing supervision.</span>
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Typography
                    component="div"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <span>e. The individual&nbsp;</span>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        row={true}
                        name="placementInMemoryCareUnit"
                        value={formData.placementInMemoryCareUnit}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: isMobile ? "start" : "center",
                          gap: 0,
                          ml: 2,
                        }}
                      >
                        <FormControlLabel
                          value="DOES require"
                          control={<Radio />}
                          label="DOES"
                        />
                        <FormControlLabel
                          value="DOES NOT require"
                          control={<Radio />}
                          label="DOES NOT"
                        />
                      </RadioGroup>
                    </FormControl>
                    <span>
                      {" "}
                      require placement in a specialized memory care unit (unit
                      with controlled access/egress designed to serve residents
                      who are at risk of engaging in unsafe wandering activities
                      or other unsafe behaviors).
                    </span>
                  </Typography>
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Typography
                    className="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px" }}
                  >
                    10. MEDICATIONS: List all medications including over the
                    counter medications, herbal remedies, topical medications,
                    vitamins, etc. Any PRN medications must include
                    instructions, i.e. parameters for use.
                  </Typography>
                  {isAddMedication && (
                    <Grid container spacing={2} sx={{ marginTop: "15px" }}>
                      <Grid item size={{ xs: 12, md: 6, lg: 3 }}>
                        <TextField
                          label="Medication"
                          placeholder="Add Medication"
                          value={formValues.Medication}
                          onChange={(e) => {
                            setFormValues({
                              ...formValues,
                              Medication: e.target.value,
                            });
                          }}
                          inputProps={{
                            maxLength: 30,
                            autoComplete: "off",
                          }}
                          sx={{
                            width: "100%",
                          }}
                        />
                      </Grid>
                      <Grid item size={{ xs: 12, md: 6, lg: 3 }}>
                        <TextField
                          label="Dosage"
                          placeholder="Add Dosage"
                          value={formValues.Dosage}
                          onChange={(e) => {
                            setFormValues({
                              ...formValues,
                              Dosage: e.target.value,
                            });
                          }}
                          inputProps={{
                            maxLength: 10,
                            autoComplete: "off",
                          }}
                          sx={{
                            width: "100%",
                          }}
                        />
                      </Grid>
                      <Grid item size={{ xs: 12, md: 6, lg: 3 }}>
                        <TextField
                          label="Directions for use"
                          placeholder="Add directions for use"
                          value={formValues.Directions}
                          onChange={(e) => {
                            setFormValues({
                              ...formValues,
                              Directions: e.target.value,
                            });
                          }}
                          inputProps={{
                            maxLength: 30,
                            autoComplete: "off",
                          }}
                          sx={{
                            width: "100%",
                          }}
                        />
                      </Grid>
                      <Grid item size={{ xs: 12, md: 6, lg: 3 }}>
                        <TextField
                          label="Route"
                          placeholder="Add Route"
                          value={formValues.Route}
                          onChange={(e) => {
                            setFormValues({
                              ...formValues,
                              Route: e.target.value,
                            });
                          }}
                          inputProps={{
                            maxLength: 13,
                            autoComplete: "off",
                            backgroundColor: "#FFFFFF",
                            borderColor: "#DDE3EA",
                          }}
                          sx={{
                            width: "100%",
                            borderColor: "#DDE3EA",
                            backgroundColor: "#FFFFFF",
                          }}
                        />
                      </Grid>
                      <Grid item size={{ xs: 12 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                            backgroundColor: "#FFFFFF",
                            padding: "10px",
                            border: "1px solid #DDE3EA",
                            borderRadius: "8px",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "text.secondary",
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <ReportProblemOutlinedIcon />
                            Does the patient require assistance taking this
                            medication?
                          </Typography>
                          <FormControlLabel
                            control={
                              <IOSSwitch
                                checked={formValues.NeedHelp === true}
                                onChange={(e) => {
                                  setFormValues({
                                    ...formValues,
                                    NeedHelp: e.target.checked,
                                  });
                                }}
                              />
                            }
                            sx={{ mr: 0 }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginY: 1,
                      gap: 1.5
                    }}
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      className={`sf-medium ${isAddMedication ? "sf-medium--light background-primary" : "sf-medium--primary"}`}
                      sx={{
                        borderColor: "#8b5cf6",
                        textTransform: "none",
                        borderRadius: "8px",
                        padding: "5px 20px",
                        cursor: "pointer",
                        width: "150px",
                        display: !isAddMedication ? "none" : "block",
                      }}
                      disabled={isDisabled}
                      onClick={() => {
                        setIsAddMedication(false);
                      }}
                    >
                      Cancel
                    </Button>
                    {!isDisabled &&
                      <Button
                        variant="outlined"
                        size="small"
                        className={`sf-medium ${isAddMedication ? "sf-medium--light background-primary" : "sf-medium--primary"}`}
                        sx={{
                          borderColor: "#8b5cf6",
                          textTransform: "none",
                          borderRadius: "8px",
                          padding: "5px 20px",
                          cursor: "pointer",
                          width: "150px",
                        }}
                        disabled={isDisabled}
                        onClick={() => {
                          handleAddMedication();
                        }}
                      >
                        {isAddMedication
                          ? formValues.id
                            ? "Update Medication"
                            : "Add to List"
                          : "Add Medication"}
                      </Button>
                    }
                  </Box>
                  <TableContainer
                    sx={{
                      border: "1px solid #DDE3EA",
                      borderRadius: "8px",
                      overflow: "hidden",
                      mt: 1,
                    }}
                  >
                    <Table aria-label="medications table" sx={{ borderCollapse: "collapse" }}>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: "#F8F9FB" }}>
                          <TableCell sx={{ fontSize: "12px", fontWeight: 600, py: 1.5, borderBottom: "1px solid #DDE3EA" }}>
                            MEDICATION
                          </TableCell>
                          <TableCell sx={{ fontSize: "12px", fontWeight: 600, py: 1.5, borderBottom: "1px solid #DDE3EA" }}>
                            DOSAGE
                          </TableCell>
                          <TableCell sx={{ fontSize: "12px", fontWeight: 600, py: 1.5, borderBottom: "1px solid #DDE3EA" }}>
                            DIRECTION FOR USE
                          </TableCell>
                          <TableCell sx={{ fontSize: "12px", fontWeight: 600, py: 1.5, borderBottom: "1px solid #DDE3EA" }}>
                            ROUTE
                          </TableCell>
                          <TableCell align="center" sx={{ fontSize: "12px", fontWeight: 600, py: 1.5, borderBottom: "1px solid #DDE3EA" }}>
                            NEEDS HELP WITH ADMINISTRATION
                          </TableCell>
                          {!isDisabled &&
                            <TableCell align="center" width={"20%"} sx={{ fontSize: "12px", fontWeight: 600, py: 1.5, borderBottom: "1px solid #DDE3EA" }}>
                              ACTION
                            </TableCell>}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {medications.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={6} align="center" sx={{ py: 4, color: "text.secondary", border: 0 }}>
                              No medications added yet
                            </TableCell>
                          </TableRow>
                        ) : (
                          medications.map((row, idx) => (
                            <TableRow
                              key={idx}
                              sx={{
                                "&:last-child td, &:last-child th": { border: 0 },
                                "&:hover": { backgroundColor: "#FAFAFA" },
                              }}
                            >
                              <TableCell sx={{ py: 1.5, borderBottom: "1px solid #EEF1F4" }}>{row.Medication}</TableCell>
                              <TableCell sx={{ py: 1.5, borderBottom: "1px solid #EEF1F4" }}>{row.Dosage}</TableCell>
                              <TableCell sx={{ py: 1.5, borderBottom: "1px solid #EEF1F4" }}>{row.Directions}</TableCell>
                              <TableCell sx={{ py: 1.5, borderBottom: "1px solid #EEF1F4" }}>{row.Route}</TableCell>
                              <TableCell align="center" sx={{ py: 1.5, borderBottom: "1px solid #EEF1F4" }}>
                                {row.NeedHelp ? "Yes" : "No"}
                              </TableCell>
                              {!isDisabled &&
                                <TableCell align="center" sx={{ py: 1.5, borderBottom: "1px solid #EEF1F4" }}>
                                  <IconButton
                                    sx={{ border: "solid 1px #7B7DE5", mr: 1 }}
                                    onClick={() => handleEditMedication(row, idx)}
                                    disabled={isDisabled}
                                  >
                                    <Edit sx={{ fontSize: 18, color: '#7B7DE5' }} />
                                  </IconButton>
                                  <IconButton
                                    sx={{ border: "solid 1px #7B7DE5" }}
                                    onClick={() => handleDeleteMedication(row.id)}
                                    disabled={isDisabled}
                                  >
                                    <Delete sx={{ fontSize: 18, color: '#7B7DE5' }} />
                                  </IconButton>
                                </TableCell>}
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* <TableContainer>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>MEDICATION</TableCell>
                          <TableCell>DOSAGE</TableCell>
                          <TableCell>DIRECTION FOR USE</TableCell>
                          <TableCell>ROUTE</TableCell>
                          <TableCell align="center">
                            NEEDS HELP
                            <br />
                            WITH ADMINISTRATION
                          </TableCell>
                          <TableCell align="center" width={"20%"}>
                            ACTION
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {medications.map((row, idx) => (
                          <TableRow
                            key={idx}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell>{row.Medication}</TableCell>
                            <TableCell>{row.Dosage}</TableCell>
                            <TableCell>{row.Directions}</TableCell>
                            <TableCell>{row.Route}</TableCell>
                            <TableCell align="center">
                              {row.NeedHelp ? "Yes" : "No"}
                            </TableCell>
                            <TableCell align="center">
                              <Button
                                sx={{
                                  boxShadow: "3px 2px 8px rgba(0, 0, 0, 0.25)",
                                  textTransform: "none",
                                  borderRadius: "6px",
                                  py: "2px",
                                  px: "0px",
                                  m: 1,
                                }}
                                onClick={() => handleEditMedication(row, idx)}
                                disabled={isDisabled}
                              >
                                <Edit
                                  sx={{
                                    mx: "2px",
                                    fontSize: 18,
                                    color: "#1E1E1EBF",
                                  }}
                                  className="color-dark"
                                />
                              </Button>
                              <Button
                                sx={{
                                  boxShadow: "3px 2px 8px rgba(0, 0, 0, 0.25)",
                                  textTransform: "none",
                                  borderRadius: "6px",
                                  py: "2px",
                                  px: "0px",
                                  m: 1,
                                }}
                                onClick={() => handleDeleteMedication(row.id)}
                                disabled={isDisabled}
                              >
                                <Delete
                                  sx={{
                                    mx: "2px",
                                    fontSize: 18,
                                    color: "#1E1E1EBF",
                                  }}
                                  className="color-dark"
                                />
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer> */}
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Typography>
                    Assisted living facilities/personal care homes ARE NOT
                    permitted under the law to provide medical, skilled nursing
                    or psychiatric care. In your professional opinion, can this
                    patient’s needs be safely met in an assisted living
                    facility/personal care home?
                  </Typography>
                  <FormControl disabled={isDisabled}>
                    <RadioGroup
                      row={true}
                      name="assistedLiving"
                      value={formData.assistedLiving}
                      onChange={handleInputChange}
                      sx={{
                        flexWrap: "nowrap", // 👈 prevents wrapping
                        alignItems: isMobile ? "start" : "center",
                        gap: 0,
                        ml: 2,
                      }}
                    >
                      <FormControlLabel
                        value="YES"
                        control={<Radio />}
                        label="YES"
                      />
                      <FormControlLabel
                        value="NO"
                        control={<Radio />}
                        label="NO"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Grid container spacing={3}>
                    <Grid item size={{ xs: 6, md: 8 }}>
                      <Typography
                        classNam="sf-regular sf-regular-dark"
                        sx={{ fontSize: "14px" }}
                      >
                        SIGNATURE OF PHYSICIAN, PA OR NP:
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="signatureOfPhysician"
                        value={formData.signatureOfPhysician}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography
                        classNam="sf-regular sf-regular-dark"
                        sx={{ fontSize: "14px" }}
                      >
                        DATE
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="date"
                        value={formData.date}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 8 }}>
                      <Typography
                        classNam="sf-regular sf-regular-dark"
                        sx={{ fontSize: "14px" }}
                      >
                        PRINTED NAME OF PHYSICIAN, PA OR NP
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="patientName"
                        value={formData.patientName}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography
                        classNam="sf-regular sf-regular-dark"
                        sx={{ fontSize: "14px" }}
                      >
                        GEORGIA LICENSE #
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="georgiaLicense"
                        value={formData.georgiaLicense}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 12 }}>
                      <Typography
                        classNam="sf-regular sf-regular-dark"
                        sx={{ fontSize: "14px" }}
                      >
                        ADDRESS OF PHYSICIAN, PA OR NP
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="physicianAddress"
                        value={formData.physicianAddress}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography
                        classNam="sf-regular sf-regular-dark"
                        sx={{ fontSize: "14px" }}
                      >
                        City
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography
                        classNam="sf-regular sf-regular-dark"
                        sx={{ fontSize: "14px" }}
                      >
                        Zip
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="zip"
                        value={formData.zip}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography
                        classNam="sf-regular sf-regular-dark"
                        sx={{ fontSize: "14px" }}
                      >
                        State
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="state"
                        value={formData.state}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12, md: 12 }}>
                  <Grid container spacing={3}>
                    <Grid item size={{ xs: 12, md: 12 }}>
                      <Typography
                        fontSize={"16px"}
                        className="sf-bold sf-bold--dark"
                        align="center"
                      >
                        PLEASE RETURN COMPLETED FORM TO:
                      </Typography>
                    </Grid>
                    <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography
                        classNam="sf-regular sf-regular--dark"
                        sx={{ fontSize: "14px" }}
                      >
                        Contact Person
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="contactPerson"
                        value={formData.contactPerson}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography
                        classNam="sf-regular sf-regular-dark"
                        sx={{ fontSize: "14px" }}
                      >
                        Facility Name
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="facilityName"
                        value={formData.facilityName}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography
                        classNam="sf-regular sf-regular-dark"
                        sx={{ fontSize: "14px" }}
                      >
                        Address
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="address"
                        value={formData.facilityAddress}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>

                    <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography classNam="sf-regular sf-regular-dark">
                        City
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="city"
                        value={formData.facilityCity}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography classNam="sf-regular sf-regular-dark">
                        Zip
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="zip"
                        value={formData.facilityState}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 4 }}>
                      <Typography classNam="sf-regular sf-regular-dark">
                        State
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="state"
                        value={formData.facilityZip}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          ) : (
            ""
          )}
        </Box>

        {formData.evaluationType === "PME & POLST" && (
          <Box sx={styles.contentBox}>
            <Box
              sx={styles.contentBoxInner}
              onClick={() => handleClickArrow("POLST")}
            >
              <Typography fontSize={"16px"} className="sf-bold sf-bold--dark">
                POLST Form
              </Typography>
              {sectionView["POLST"] === true ? (
                <ExpandLess sx={{ fontSize: 24 }} className="color-primary" />
              ) : (
                <ExpandMore sx={{ fontSize: 24 }} className="color-primary" />
              )}
            </Box>
            <Divider sx={{ width: "100%" }} />
            {sectionView["POLST"] === true ? (
              <Box sx={{ p: 2 }}>
                <Grid container spacing={2}>
                  <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography
                      className="sf-medium sf-medium-dark"
                      sx={{ fontSize: "18px" }}
                    >
                      A. Cardiopulmonary Resuscitation (CPR)
                    </Typography>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        name="cardiopulmonaryResuscitation"
                        value={formData.cardiopulmonaryResuscitation}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: "start",
                          gap: 0,
                        }}
                      >
                        <FormControlLabel
                          value="Yes,Attempt Resuscitation (CPR)"
                          control={<Radio />}
                          label="Attempt Resuscitation/CPR"
                        />
                        <FormControlLabel
                          value="No,Allow Natural Death (AND) - Do Not Attempt Resuscitation"
                          control={<Radio />}
                          label="Allow Natural Death (AND) - Do Not Attempt Resuscitation"
                        />
                        {/* <FormControlLabel
                          value="Resuscitation orders to remain in effect during surgical/invasive procedures."
                          control={<Radio />}
                          label="Resuscitation orders to remain in effect during surgical/invasive procedures."
                        /> */}
                      </RadioGroup>
                      <RadioGroup
                        name="cardiopulmonaryResuscitationOrders"
                        value={formData.cardiopulmonaryResuscitationOrders}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: "start",
                          gap: 0,
                        }}
                      >
                        <FormControlLabel
                          value="Yes"
                          control={<Radio />}
                          label="Resuscitation orders to remain in effect during surgical/invasive procedures."
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Divider sx={{ width: "100%" }} />
                  <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography
                      className="sf-medium sf-medium-dark"
                      sx={{ fontSize: "18px" }}
                    >
                      B. Medical Interventions
                    </Typography>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        name="medicalInterventions"
                        value={formData.medicalInterventions}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: "start",
                          gap: 0,
                        }}
                      >
                        <FormControlLabel
                          value="Comfort Measures: Use medication by any route, positioning, wound care, and other measures to relieve pain and suffering. Use oxygen, suction, and manual treatment of airway obstruction as needed for comfort. Do not transfer to hospital for life-sustaining treatment."
                          control={<Radio />}
                          label="Comfort Measures Only"
                        />
                        <FormControlLabel
                          value="Limited Additional Interventions: In addition to treatment and care described above, provide medical treatment, as indicated. DO NOT USE intubation or mechanical ventilation. Transfer to hospital if indicated."
                          control={<Radio />}
                          label="Limited Additional Interventions"
                        />
                        <FormControlLabel
                          value="Additional Treatment (Includes Limited Additional + lab tests, blood products, dialysis; transfer to hospital if indicated.)"
                          control={<Radio />}
                          label="Additional Treatment"
                        />
                        <FormControlLabel
                          value="Full Treatment: In addition to treatment and care described above, use intubation, mechanical ventilation, and cardioversion as indicated. Transfer to hospital and/or intensive care unit if indicated."
                          control={<Radio />}
                          label="Full Treatment"
                        />
                        <FormControlLabel
                          value="Additional Orders (e.g. dialysis):"
                          control={<Radio />}
                          label="Additional Orders"
                        />
                        <TextField
                          fullWidth
                          type="text"
                          name="medicalInterventionsORders"
                          value={formData.medicalInterventionsORders}
                          onChange={handleInputChange}
                          disabled={
                            formData.medicalInterventions !==
                            "Additional Orders (e.g. dialysis):" || isDisabled
                          } // 👈 optional but recommended
                          sx={{
                            mb: 1,
                          }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Divider sx={{ width: "100%" }} />
                  <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography
                      className="sf-medium sf-medium-dark"
                      sx={{ fontSize: "18px" }}
                    >
                      C. Antibiotics
                    </Typography>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        name="antibiotics"
                        value={formData.antibiotics}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: "start",
                          gap: 0,
                        }}
                      >
                        <FormControlLabel
                          value="No antibiotics: Use other measures to relieve symptoms."
                          control={<Radio />}
                          label="No antibiotics"
                        />
                        <FormControlLabel
                          value="Determine use or limitation of antibiotics when infection occurs."
                          control={<Radio />}
                          label="Determine use when infection occurs"
                        />
                        <FormControlLabel
                          value="Use antibiotics if life can be prolonged."
                          control={<Radio />}
                          label="Use if life can be prolonged"
                        />
                        <FormControlLabel
                          value="Additional Order"
                          control={<Radio />}
                          label="Additional Orders"
                        />
                        <TextField
                          fullWidth
                          type="text"
                          name="antibioticsOrders"
                          value={formData.antibioticsOrders}
                          onChange={handleInputChange}
                          disabled={
                            formData.antibiotics !== "Additional Order" ||
                            isDisabled
                          } // 👈 optional but recommended
                          sx={{
                            mb: 1,
                          }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Divider sx={{ width: "100%" }} />
                  <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography
                      className="sf-medium sf-medium-dark"
                      sx={{ fontSize: "18px" }}
                    >
                      D. Nutrition / Fluids
                    </Typography>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        name="artificiallyAdministeredFluids"
                        value={formData.artificiallyAdministeredFluids}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: "start",
                          gap: 0,
                        }}
                      >
                        <FormControlLabel
                          value="No artificial nutrition by tube"
                          control={<Radio />}
                          label="No artificial nutrition"
                        />
                        <FormControlLabel
                          value="Defined trial period of artificial nutrition by tube"
                          control={<Radio />}
                          label="Defined trial period of artificial nutrition by tube."
                        />
                        <FormControlLabel
                          value="Long-term artificial nutrition by tube"
                          control={<Radio />}
                          label="Long-term artificial nutrition by tube"
                        />
                        <FormControlLabel
                          value="No IV fluids"
                          control={<Radio />}
                          label="No IV fluids."
                        />
                        <FormControlLabel
                          value="Defined trial period of IV fluids"
                          control={<Radio />}
                          label="Defined trial period of IV fluids"
                        />
                        <FormControlLabel
                          value="Long-term IV fluids"
                          control={<Radio />}
                          label="Long-term IV fluid"
                        />
                        <FormControlLabel
                          value="Additional Order"
                          control={<Radio />}
                          label="Additional Orders"
                        />
                        <TextField
                          fullWidth
                          type="text"
                          name="artificiallyAdministeredFluidsOrders"
                          value={formData.artificiallyAdministeredFluidsOrders}
                          onChange={handleInputChange}
                          disabled={
                            formData.artificiallyAdministeredFluids !==
                            "Additional Order" || isDisabled
                          } // 👈 optional but recommended
                          sx={{
                            mb: 1,
                          }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  {/* <Divider sx={{ width: "100%" }} /> */}
                  {/* <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography
                      className="sf-medium sf-medium-dark"
                      sx={{ fontSize: "18px" }}
                    >
                      E. Reason For Orders and Signatures
                    </Typography>
                    <Typography
                      className="sf-regular sf-regular-dark"
                      sx={{ fontSize: "14px" }}
                    >
                      To the best of my knowledge these orders are consistent
                      with the patient’s current medical condition and
                      preferences as indicated by:
                    </Typography>
                    <FormControl disabled={isDisabled}>
                      <RadioGroup
                        name="dietInstructions"
                        value={formData.dietInstructions}
                        onChange={handleInputChange}
                        sx={{
                          flexWrap: "nowrap", // 👈 prevents wrapping
                          alignItems: "start",
                          gap: 0,
                        }}
                      >
                        <FormControlLabel
                          value="My discussion with the Patient"
                          control={<Radio />}
                          label="My discussion with the Patient"
                        />
                        <FormControlLabel
                          value="My review of the Patient’s Advance Directive"
                          control={<Radio />}
                          label="My review of the Patient’s Advance Directive"
                        />
                        <FormControlLabel
                          value="My discussion with the Patient’s Authorized Representative"
                          control={<Radio />}
                          label="My discussion with the Patient’s Authorized Representative"
                        />
                        <FormControlLabel
                          value="Verbal consent was given for an “allow natural death” order."
                          control={<Radio />}
                          label="Verbal consent was given for an “allow natural death” order."
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid> */}
                  {/* <Divider sx={{ width: "100%" }} />
                  <Grid item size={{ xs: 12, md: 12 }}>
                    <Grid container spacing={3}>
                      <Grid item size={{ xs: 6, md: 8 }}>
                        <Typography
                          classNam="sf-regular sf-regular-dark"
                          sx={{ fontSize: "14px" }}
                        >
                          SIGNATURE OF PHYSICIAN, PA OR NP:
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          name="signatureOfPhysician"
                          value={formData.signatureOfPhysician}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </Grid>
                      <Grid item size={{ xs: 6, md: 4 }}>
                        <Typography
                          classNam="sf-regular sf-regular-dark"
                          sx={{ fontSize: "14px" }}
                        >
                          DATE
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          name="date"
                          value={formData.date}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </Grid>
                      <Grid item size={{ xs: 6, md: 8 }}>
                        <Typography
                          classNam="sf-regular sf-regular-dark"
                          sx={{ fontSize: "14px" }}
                        >
                          PRINTED NAME OF PHYSICIAN, PA OR NP
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          name="patientName"
                          value={formData.patientName}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </Grid>
                      <Grid item size={{ xs: 6, md: 4 }}>
                        <Typography
                          classNam="sf-regular sf-regular-dark"
                          sx={{ fontSize: "14px" }}
                        >
                          GEORGIA LICENSE #
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          name="georgiaLicense"
                          value={formData.georgiaLicense}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </Grid>
                      <Grid item size={{ xs: 12, md: 12 }}>
                        <Typography
                          classNam="sf-regular sf-regular-dark"
                          sx={{ fontSize: "14px" }}
                        >
                          ADDRESS OF PHYSICIAN, PA OR NP
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          name="physicianAddress"
                          value={formData.physicianAddress}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </Grid>
                      <Grid item size={{ xs: 6, md: 4 }}>
                        <Typography
                          classNam="sf-regular sf-regular-dark"
                          sx={{ fontSize: "14px" }}
                        >
                          City
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          name="city"
                          value={formData.city}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </Grid>
                      <Grid item size={{ xs: 6, md: 4 }}>
                        <Typography
                          classNam="sf-regular sf-regular-dark"
                          sx={{ fontSize: "14px" }}
                        >
                          Zip
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          name="zip"
                          value={formData.zip}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </Grid>
                      <Grid item size={{ xs: 6, md: 4 }}>
                        <Typography
                          classNam="sf-regular sf-regular-dark"
                          sx={{ fontSize: "14px" }}
                        >
                          State
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          name="state"
                          value={formData.state}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Divider sx={{ width: "100%" }} />
                  <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography
                      fontSize={"16px"}
                      className="sf-bold sf-bold--dark"
                      align="center"
                    >
                      DIRECTIONS FOR HEALTHCARE PROFESSIONALS
                    </Typography>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography
                      className="sf-regular sf-regular--dark"
                      component="ul"
                      sx={{ pl: 3 }}
                    >
                      <li>
                        This form should be completed by a health care
                        professional based on the patient’s medical condition,
                        and on the patient’s wishes, as expressed to the
                        physician by the patient while in a competent condition,
                        or in the patient’s advance directive, or by a
                        representative of the patient acting with legal
                        authority.
                      </li>
                      <li>
                        This form should be signed by a physician, and also by
                        the patient or a representative acting with legal
                        authority on behalf of the patient.
                      </li>
                      <li>
                        Use of original form is strongly encouraged. Photocopies
                        and faxes of signed POLST forms are valid.
                      </li>
                      <li>
                        Any incomplete section of POLST implies full treatment
                        for that section.
                      </li>
                      <li>
                        Do not use a defibrillator (including AEDs) on a person
                        who has chosen “allow natural death.”
                      </li>
                      <li>
                        Always offer fluids and nutrition by mouth if medically
                        feasible.
                      </li>
                      <li>
                        Transfer the patient to a setting better able to provide
                        comfort when it cannot be achieved in the current care
                        setting (e.g., treatment of a hip fracture).
                      </li>
                      <li>
                        A patient with capacity, or the authorized
                        representative of a patient without capacity, may
                        request alternative treatment.
                      </li>
                      <li>
                        Treatment of dehydration is a measure which prolongs
                        life. A patient who desires IV fluids should indicate
                        “Limited Additional Intervention” or higher level of
                        care.
                      </li>
                    </Typography>
                  </Grid> */}
                </Grid>
              </Box>
            ) : (
              ""
            )}
          </Box>
        )}

        <Box sx={{ ...styles.contentBox, display: formData?.skinIntegrity !== "No" ? "block" : "none" }}>
          <Box
            sx={styles.contentBoxInner}
            onClick={() => handleClickArrow("OTHER")}
          >
            <Typography fontSize={"16px"} className="sf-bold sf-bold--dark">
              Other
            </Typography>
            {sectionView["OTHER"] === true ? (
              <ExpandLess sx={{ fontSize: 24 }} className="color-primary" />
            ) : (
              <ExpandMore sx={{ fontSize: 24 }} className="color-primary" />
            )}
          </Box>
          <Divider sx={{ width: "100%" }} />
          {sectionView["OTHER"] === true ? (
            <Box sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    1. How long have the resident had the wound?
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="woundPeriod"
                    value={formData.woundPeriod}
                    onChange={handleInputChange}
                    disabled={isDisabled}
                  />
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    2. How has the wound been treated?
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="woundTreatement"
                    value={formData.woundTreatement}
                    onChange={handleInputChange}
                    disabled={isDisabled}
                  />
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    3. Who is treating the wound?
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="woundTreatementPhysician"
                    value={formData.woundTreatementPhysician}
                    onChange={handleInputChange}
                    disabled={isDisabled}
                  />
                </Grid>
                {/* <Divider sx={{ width: "100%" }} /> */}
                {/* <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    4. What is the name of the resident's health insurance
                    provider?
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="supportiveServices"
                    // value={formData.supportiveServices}
                    // onChange={handleInputChange}

                    disabled={isDisabled}
                  />
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    5. What is the resident's subscription number?
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="supportiveServices"
                    // value={formData.supportiveServices}
                    // onChange={handleInputChange}

                    disabled={isDisabled}
                  />
                </Grid>
                <Divider sx={{ width: "100%" }} />
                <Grid item size={{ xs: 12 }}>
                  <Typography
                    classNam="sf-medium sf-medium-dark"
                    sx={{ fontSize: "18px", mb: 1 }}
                  >
                    6. Does the resident's insurance card have a group number?
                    if so, what is the number?
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="supportiveServices"
                    // value={formData.supportiveServices}
                    // onChange={handleInputChange}

                    disabled={isDisabled}
                  />
                </Grid> */}
              </Grid>
            </Box>
          ) : (
            ""
          )}
        </Box>

        <Box sx={{
          position: 'fixed',
          bottom: 0,
          right: '19px',
          padding: '7px 10px',
          backgroundColor: '#ffffff',
          border: '1px solid #ccc',
          borderRadius: '8px 8px 0px 0px',
          display: "flex",
          justifyContent: "flex-end",
          gap: 1
        }}>
          <Button
            variant="outlined"
            className="sf-medium sf-medium--primary"
            onClick={() => {
              guardedNavigate(navigate, -1);
            }}
          >
            BACK
          </Button>
          {isSubmitted === false && (
            <Button
              variant="contained"
              className="sf-medium sf-medium--light background-primary"
              disabled={isDisabled}
              onClick={handleSaveForm}
            >
              {isLoading === true ? (
                <CircularProgress color="#5855eb" size={"22px"} />
              ) : (
                "SAVE"
              )}
            </Button>
          )}
        </Box>

      </Box>
    </Box>


  );
};

export default ReviewPatientForm;
